var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "file-preview-modal",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.handleClose.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "preview-container" }, [
            _c("div", { staticClass: "preview-header" }, [
              _c("div", { staticClass: "file-info" }, [
                _c("span", { staticClass: "file-name" }, [
                  _vm._v(_vm._s(_vm.currentFile.name)),
                ]),
                _vm._v(" "),
                _vm.files.length > 1
                  ? _c("span", { staticClass: "file-counter" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.currentIndex + 1) +
                          " / " +
                          _vm._s(_vm.files.length) +
                          "\n                "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "header-actions" },
                [
                  _c(
                    "a-tooltip",
                    { attrs: { title: _vm.$t("googleDrive.download") } },
                    [
                      _c(
                        "a-button",
                        {
                          staticClass: "action-btn",
                          attrs: { type: "link", loading: _vm.downloading },
                          on: { click: _vm.handleDownload },
                        },
                        [_c("a-icon", { attrs: { type: "download" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-tooltip",
                    { attrs: { title: _vm.$t("googleDrive.openInNewTab") } },
                    [
                      _c(
                        "a-button",
                        {
                          staticClass: "action-btn",
                          attrs: { type: "link" },
                          on: { click: _vm.handleOpenInNewTab },
                        },
                        [_c("a-icon", { attrs: { type: "export" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      staticClass: "action-btn close-btn",
                      attrs: { type: "link" },
                      on: { click: _vm.handleClose },
                    },
                    [_c("a-icon", { attrs: { type: "close" } })],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.files.length > 1
              ? _c(
                  "button",
                  {
                    staticClass: "nav-arrow nav-prev",
                    attrs: {
                      disabled: _vm.currentIndex === 0,
                      type: "button",
                      "aria-label": _vm.$t("googleDrive.previewPreviousFile"),
                    },
                    on: { click: _vm.goToPrev },
                  },
                  [_c("a-icon", { attrs: { type: "left" } })],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.files.length > 1
              ? _c(
                  "button",
                  {
                    staticClass: "nav-arrow nav-next",
                    attrs: {
                      disabled: _vm.currentIndex === _vm.files.length - 1,
                      type: "button",
                      "aria-label": _vm.$t("googleDrive.previewNextFile"),
                    },
                    on: { click: _vm.goToNext },
                  },
                  [_c("a-icon", { attrs: { type: "right" } })],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "preview-content" }, [
              _vm.loading
                ? _c(
                    "div",
                    { staticClass: "loading-state" },
                    [_c("a-spin", { attrs: { size: "large" } })],
                    1
                  )
                : _vm.isImage
                ? _c("div", { staticClass: "image-preview" }, [
                    _c("img", {
                      attrs: { src: _vm.previewUrl, alt: _vm.currentFile.name },
                      on: { load: _vm.onImageLoad, error: _vm.onLoadError },
                    }),
                  ])
                : _vm.isVideo
                ? _c("div", { staticClass: "video-preview" }, [
                    _c("iframe", {
                      attrs: {
                        src: _vm.googleDriveEmbedUrl,
                        frameborder: "0",
                        allowfullscreen: "",
                        allow: "autoplay",
                      },
                    }),
                  ])
                : _vm.isPdf
                ? _c("div", { staticClass: "pdf-preview" }, [
                    _c("iframe", {
                      attrs: { src: _vm.googleDriveEmbedUrl, frameborder: "0" },
                    }),
                  ])
                : _vm.isGoogleDoc
                ? _c("div", { staticClass: "google-docs-preview" }, [
                    _c("iframe", {
                      attrs: {
                        src: _vm.googleDocsPreviewUrl,
                        frameborder: "0",
                      },
                    }),
                  ])
                : _c("div", { staticClass: "file-card-preview" }, [
                    _c("div", { staticClass: "file-card-content" }, [
                      _c(
                        "div",
                        { staticClass: "file-icon-large" },
                        [
                          _c("a-icon", {
                            attrs: {
                              type: _vm.getFileIcon(_vm.currentFile.mimeType),
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("h3", { staticClass: "file-card-name" }, [
                        _vm._v(_vm._s(_vm.currentFile.name)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "file-card-details" }, [
                        _vm.currentFile.size
                          ? _c("p", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("googleDrive.fileSize")) + ":"
                                ),
                              ]),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.formatBytes(_vm.currentFile.size)
                                  ) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentFile.mimeType
                          ? _c("p", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("googleDrive.fileType")) + ":"
                                ),
                              ]),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.getReadableMimeType(
                                      _vm.currentFile.mimeType
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentFile.modifiedTime
                          ? _c("p", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("googleDrive.modifiedTime")) +
                                    ":"
                                ),
                              ]),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.formatDate(_vm.currentFile.modifiedTime)
                                  ) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentFile.owners && _vm.currentFile.owners.length
                          ? _c("p", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("googleDrive.owner")) + ":"
                                ),
                              ]),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.currentFile.owners
                                      .map(function (o) {
                                        return o.displayName || o.emailAddress
                                      })
                                      .join(", ")
                                  ) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "file-card-message" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("googleDrive.previewNotAvailable")) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "file-card-actions" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.downloading,
                              },
                              on: { click: _vm.handleDownload },
                            },
                            [
                              _c("a-icon", { attrs: { type: "download" } }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("googleDrive.downloadToSupsis")
                                  ) +
                                  "\n                        "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            { on: { click: _vm.handleOpenInNewTab } },
                            [
                              _c("a-icon", { attrs: { type: "export" } }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("googleDrive.openInGoogleDrive")
                                  ) +
                                  "\n                        "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
            ]),
            _vm._v(" "),
            _vm.files.length > 1
              ? _c(
                  "div",
                  { staticClass: "thumbnails-strip" },
                  _vm._l(_vm.files, function (file, index) {
                    return _c(
                      "div",
                      {
                        key: file.id,
                        staticClass: "thumbnail-item",
                        class: { active: index === _vm.currentIndex },
                        on: {
                          click: function ($event) {
                            return _vm.goToIndex(index)
                          },
                        },
                      },
                      [
                        file.thumbnailLink
                          ? _c("img", {
                              attrs: {
                                src: file.thumbnailLink,
                                alt: file.name,
                              },
                            })
                          : _c("a-icon", {
                              attrs: { type: _vm.getFileIcon(file.mimeType) },
                            }),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }